// extracted by mini-css-extract-plugin
export default {"cls1":"qWSxWA1ep5bbhCPTasa6","cls2":"TcL5qty96Q2hDyUMLDMQ qWSxWA1ep5bbhCPTasa6"};